import NoAffiliateAuthModal from '@components/common/modals/affiliateModal/noAffiliateAuthModal';
import LoginModal from '@components/loginModal';
import InfoDetailRecommendHeader from './header';
import InfoDetailRecommendList from './list';
import { InfoCardVO } from '@domain/vo/info/infoCardVO';
import useContentAccessControl from '@utils/hooks/useContentAccessControl';
import classnames from 'classnames/bind';
import styles from './infoDetailRecommend.module.scss';

const cx = classnames.bind(styles);

interface Props {
  cardList?: InfoCardVO[];
}

const InfoDetailRecommend = (props: Props) => {
  const { cardList } = props;

  const {
    handleCardClick,
    loginModalVisible,
    noAffiliateAuthModalVisible,
    redirectUrl,
    setLoginModalVisible,
    setNoAffiliateAuthModalVisible,
    noAffiliateAuthModalTitle,
  } = useContentAccessControl();

  return (
    <div className={cx('recommendArea')}>
      <InfoDetailRecommendHeader />
      <InfoDetailRecommendList cardList={cardList} handleClick={handleCardClick} />

      <LoginModal
        subTitle="채용정보 · 역량검사 · 매칭까지"
        title="취업기회 지금 바로 잡다!"
        visible={loginModalVisible}
        onClose={() => setLoginModalVisible(false)}
        redirectUrl={redirectUrl}
      />
      <NoAffiliateAuthModal
        title={noAffiliateAuthModalTitle}
        visible={noAffiliateAuthModalVisible}
        onClose={() => setNoAffiliateAuthModalVisible(false)}
      />
    </div>
  );
};

export default InfoDetailRecommend;
